import { TableCell, makeStyles } from "@material-ui/core";
import { flexRender } from "@tanstack/react-table";
import ColumnsFilter from "./ColumnsFilter";
import Box from "@material-ui/core/Box";
import Grid from "@material-ui/core/Grid";
import { cellStickPositionFinder } from "./TableUtils.js";
import ArrowUpwardIcon from "@material-ui/icons/ArrowUpward";
import ArrowDownwardIcon from "@material-ui/icons/ArrowDownward";

const HeaderCell = (cellProps) => {
  const { header, stickRight, table, colSpan } = cellProps;

  const isFilterable = header.column.getCanFilter();
  const isSortable = header?.column?.getCanSort();
  const isSticky = header.column.getIsPinned();

  const activeSortIcon =
    {
      asc: <ArrowUpwardIcon color="primary" style={{ fontSize: "16px" }} />,
      desc: <ArrowDownwardIcon color="primary" style={{ fontSize: "16px" }} />,
    }[header.column.getIsSorted()] ?? null;

  const {
    header: columnName,
    id: columnId,
    required,
  } = header.column.columnDef;

  const columnIdentifier = columnId?.toLowerCase() + "_header_cell_";
  const isCenterAlignHeader = columnId === "edit";
  const isEditColumn = columnId === "edit";
  return (
    <TableCell
      style={{
        right: stickRight ? 0 : "",
        width: isEditColumn ? "8rem" : "11rem",
        borderLeft: isEditColumn ? "2px solid silver" : "",
        borderRight: isSticky === "left" ? "2px solid silver" : "",
        zIndex: isSticky ? 10 : 9,
        minWidth: isEditColumn ? "8rem" : "11rem",
      }}
      className={`live-view-header-cell-style ${columnIdentifier}`}
      padding="none"
      size="small"
      align={colSpan > 1 ? "center" : "left"}
      key={header.id}
      colSpan={colSpan || 1}
    >
      <Grid
        container
        className={`${
          isCenterAlignHeader
            ? "live-view-edit-cell-container"
            : "live-view-cell-container"
        }`}
      >
        <Grid
          item
          xs={isCenterAlignHeader ? 12 : 9}
          className={`live-view-common-flex`}
        >
          <div
            {...(isSortable && {
              onClick: header?.column?.getToggleSortingHandler(),
            })}
            style={{
              textAlign: isCenterAlignHeader ? "center" : "left",
              width: "100%",
              backgroundColor: "#fff",
              cursor: isSortable ? "pointer" : "text",
              ...cellStickPositionFinder(isSticky),
            }}
          >
            {header.isPlaceholder
              ? null
              : flexRender(columnName, header.getContext())}
            {`${required ? "*" : ""}`}
          </div>
        </Grid>
        <Grid item xs={1} className={`live-view-common-flex`}>
          {isSortable ? activeSortIcon : null}
        </Grid>
        <Grid item xs={2} className={`live-view-common-flex`}>
          {isFilterable ? (
            <ColumnsFilter table={table} column={header.column} />
          ) : null}
        </Grid>
      </Grid>
    </TableCell>
  );
};

export default HeaderCell;
